import styled from '@emotion/styled';
import { Grid } from '@mui/material';

export const Container = styled(Grid)`
  .header-row {
    background-color: aliceblue;
    &:hover {
      background-color: aliceblue;
    }
  }
`;

export const ActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};
`;
